module.exports = "<svg xmlns=http://www.w3.org/2000/svg width=21 height=24 viewBox=\"0 0 21 24\"> <g fill=none fill-rule=evenodd stroke=#FFF> <path d=\"M10.435 2.087c1.64 0 3.472.348 5.217 2.54 1.826 2.292 1.192 8.546 2.009 10.257.544 1.141 1.216 2.093 2.015 2.855M8.928 1.587h3.013a1.588 1.588 0 0 0-3.013 0zM7.852 21.37h5.166a2.631 2.631 0 0 1-5.166 0z\"/> <path d=\"M10.691 2.087c-1.64 0-3.598.41-5.4 2.468-1.736 1.983-1.31 8.02-1.679 9.885-.246 1.242-.893 2.231-1.943 2.966\"/> <rect width=19.87 height=4.217 x=.5 y=17.196 rx=2.109 /> </g> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/terminal-page/notification.svg
// module id = LYxD
// module chunks = 15